import React, { useRef, useState, useEffect } from "react";
import { extend, useFrame } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import gsap from 'gsap';

extend({ OrbitControls });

const Coin = () => {
  const [model, setModel] = useState(null);
  const meshRef = useRef();

  useEffect(() => {
    new GLTFLoader().load(
      process.env.PUBLIC_URL + "models/coin/coin.gltf",
      setModel
    );
  }, []);

  useFrame(({ mouse }) => {
    const { x, y } = mouse;
    gsap.to(meshRef.current.rotation, {
      x: Math.PI / -8 + y * 0.2,
      y: Math.PI / 6.3 + x * 0.2,
      duration: 0.5,
    });
  });

  if (meshRef.current) {
    meshRef.current.rotation.x = Math.PI / -8;
    meshRef.current.rotation.y = Math.PI / 6.3;
  }

  return (
    <mesh ref={meshRef}>{model && <primitive object={model.scene} />}</mesh>
  );
};

export default Coin;
